export const callListHeaders = [
  {
    text: "User",
    value: "user_id",
    sortable: false
  },
  {
    text: "Location Code",
    value: "location_code"
  },
  {
    text: "Call Type",
    value: "call_type_id",
    sortable: false
  },
  {
    text: "Call Date",
    value: "created_at"
  },
  {
    text: "Disposition Type",
    value: "disposition_id"
  },
  {
    text: "Contact Phone",
    value: "contact_phone"
  },
  {
    text: "Actions",
    value: "actions",
    sortable: false
  }
];
